import { render, staticRenderFns } from "./TodoSupportHandlerSidebar.vue?vue&type=template&id=9ec3da18&scoped=true&"
import script from "./TodoSupportHandlerSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoSupportHandlerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoSupportHandlerSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoSupportHandlerSidebar.vue?vue&type=style&index=1&id=9ec3da18&lang=scss&scoped=true&"
import style2 from "./TodoSupportHandlerSidebar.vue?vue&type=style&index=2&id=9ec3da18&scoped=true&lang=css&"
import style3 from "./TodoSupportHandlerSidebar.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec3da18",
  null
  
)

export default component.exports